export default __webpack_public_path__ + "static/media/dev.8841bd56.svg";